import React from 'react';
import './LoiVersionSelect.scss';
import { Input } from 'reactstrap';
import {
    getLastCompletedLoiProcess,
    isLoiProcessCompleted,
    isLoiProcessSuperseded,
    LoiFormsProcess,
} from '../../slices/marketplace/loi-comparison/models/loi-forms-process.model';

export interface LoiVersionSelectProps {
    processes: LoiFormsProcess[];
    isResubmission: boolean;
    currentLoiFormId: string | undefined;
    value: string;
    onChange: (loiFormId: string) => void;
    selectId?: string;
}

export const LoiVersionSelect = ({
    processes,
    isResubmission,
    currentLoiFormId,
    value,
    onChange,
    selectId = 'loi-version-select',
}: LoiVersionSelectProps) => {
    const historicalProcesses = [...processes]
        .filter((p) => isLoiProcessCompleted(p) || isLoiProcessSuperseded(p))
        .sort((a, b) => (a.completedAt ?? '').localeCompare(b.completedAt ?? ''));
    const lastCompletedLoiFormId = getLastCompletedLoiProcess(processes)?.loiFormId;

    const versionOptionCount = historicalProcesses.length + (isResubmission ? 1 : 0);

    if (versionOptionCount <= 1) {
        return null;
    }

    return (
        <div className="loi-version-selector">
            <label htmlFor={selectId}>Version:</label>
            <Input
                type="select"
                id={selectId}
                value={value}
                onChange={(e) => onChange(e.target.value)}
            >
                {historicalProcesses.map((process) => {
                    const isActive = process.loiFormId === lastCompletedLoiFormId;
                    const label = isActive
                        ? `Active — ${new Date(process.completedAt!).toLocaleDateString()}`
                        : new Date(process.completedAt!).toLocaleDateString();
                    return (
                        <option key={process.loiFormId} value={process.loiFormId}>
                            {label}
                        </option>
                    );
                })}
                {isResubmission && (
                    <option value={currentLoiFormId}>Resubmission</option>
                )}
            </Input>
        </div>
    );
};
